var map = {
	"./imgs/candidatos/Ana Alejandrina Pineda Hernández.jpg": 20505,
	"./imgs/candidatos/Anabelly Suyapa Medina Moncada.jpg": 23410,
	"./imgs/candidatos/Anny Belinda Ochoa Medrano.jpg": 87335,
	"./imgs/candidatos/Aída Estela Romero Reyes.jpg": 83739,
	"./imgs/candidatos/Aída Patricia Martínez Linares.jpg": 97874,
	"./imgs/candidatos/Danelia Ferrera Turcios.jpg": 39124,
	"./imgs/candidatos/Daniel Arturo Sibrián Bueso.jpg": 41620,
	"./imgs/candidatos/Edin Yobany de la O Ramos.jpg": 55709,
	"./imgs/candidatos/Felipe René Speer Laínez.jpg": 99997,
	"./imgs/candidatos/Francisca Villela Zavala.jpg": 37652,
	"./imgs/candidatos/Francisco Javier Mejía Sánchez.jpg": 29949,
	"./imgs/candidatos/Gaudy Alejandra Bustillo Martínez.jpg": 32304,
	"./imgs/candidatos/Gessenia López Zepeda.jpg": 97268,
	"./imgs/candidatos/Gloria Bertilia Oyuela Carrasco.jpg": 79355,
	"./imgs/candidatos/Isbela Bustillo Hernández.jpg": 76149,
	"./imgs/candidatos/José María Díaz Ávila.jpg": 9690,
	"./imgs/candidatos/José Ricardo Pineda Medina.jpg": 42334,
	"./imgs/candidatos/Juan Wilfredo Castellanos Hipp.jpg": 65368,
	"./imgs/candidatos/Karen Lizeth Martínez Ponce.jpg": 31546,
	"./imgs/candidatos/Liliana Patricia Paz Pagoaga.jpg": 5984,
	"./imgs/candidatos/Linda Patricia Reyes Interiano.jpg": 31926,
	"./imgs/candidatos/Luis Alonso Discua Cerrato.jpg": 89066,
	"./imgs/candidatos/Luis Fernando Padilla Castellanos.jpg": 97590,
	"./imgs/candidatos/Malcon Eduardo Guzmán Velásquez.jpg": 81072,
	"./imgs/candidatos/Manuel Enrique Cálix Bonilla.jpg": 94145,
	"./imgs/candidatos/Marcio Beyran Membreño Villela.jpg": 36313,
	"./imgs/candidatos/Marco Vinicio Montes Tavarone.jpg": 39191,
	"./imgs/candidatos/Mario Donaldo Díaz Flores.jpg": 79438,
	"./imgs/candidatos/Mario Rolando Acosta Cárcamo.jpg": 60904,
	"./imgs/candidatos/Martha Delia Merino Conde.jpg": 21301,
	"./imgs/candidatos/Marvin Rigoberto Espinal Pinel.jpg": 67146,
	"./imgs/candidatos/María de Jesús Palacios Zelaya.jpg": 20468,
	"./imgs/candidatos/Milton Danilo Jiménez Puerto.jpg": 55747,
	"./imgs/candidatos/Nelson Danilo Mairena Franco.jpg": 57296,
	"./imgs/candidatos/Odalis Aleyda Nájera Medina.jpg": 80247,
	"./imgs/candidatos/Rebeca Lizette Ráquel Obando.jpg": 40114,
	"./imgs/candidatos/Roxana Liceth Morales Toro.jpg": 61707,
	"./imgs/candidatos/Roy Pineda Castro.jpg": 85983,
	"./imgs/candidatos/Rubenia Esperanza Galeano Barralaga.jpg": 60157,
	"./imgs/candidatos/Sandra Lizeth Avelar Rajo.jpg": 43302,
	"./imgs/candidatos/Sonia Marlina Dubón Villeda.jpg": 57975,
	"./imgs/candidatos/Tirza del Carmen Flores Lanza.jpg": 41164,
	"./imgs/candidatos/Wagner Vallecillo Paredes.jpg": 99691,
	"./imgs/candidatos/Walter Raúl Miranda Sabio.jpg": 18704,
	"./imgs/candidatos/Yuri Fernando Malara Berlíoz.jpg": 16389,
	"./imgs/congresistas/ADELA ESMERALDA MARTINEZ .jpg": 50994,
	"./imgs/congresistas/ADELA ESMERALDA MARTINEZ.jpg": 76952,
	"./imgs/congresistas/ADRIAN JOSUE MARTINEZ SOLER.jpg": 36431,
	"./imgs/congresistas/ADRIANA CASTELLANOS ESCOTO .jpg": 20981,
	"./imgs/congresistas/ADRIANA CASTELLANOS ESCOTO.jpg": 21817,
	"./imgs/congresistas/ALBERTO CHEDRANI CASTANEDA .jpg": 45610,
	"./imgs/congresistas/ALBERTO CHEDRANI CASTAÑEDA.jpg": 84757,
	"./imgs/congresistas/ALBERTO EMILIO CRUZ ZELAYA.jpg": 41789,
	"./imgs/congresistas/ALEYDA ANTONIA ALVAREZ SIERRA.jpg": 91196,
	"./imgs/congresistas/ALLAN EDGARDO CARCAMO RAMIREZ.jpg": 57223,
	"./imgs/congresistas/ALLAN WILMER AGUIRIANO .jpg": 86452,
	"./imgs/congresistas/ALLAN WILMER AGUIRIANO.jpg": 98302,
	"./imgs/congresistas/ANAEL MENDEZ RIVERA .jpg": 33654,
	"./imgs/congresistas/ANAEL MENDEZ RIVERA.jpg": 84708,
	"./imgs/congresistas/ANDREA VALESKA REYES SANTOS.jpg": 68701,
	"./imgs/congresistas/ANDRES ALFREDO CASTRO TURCIOS.jpg": 20602,
	"./imgs/congresistas/ANGEL ADELSO REYES AGUILAR.jpg": 56889,
	"./imgs/congresistas/ANGELICA MARIA GARCIA MEJIA.jpg": 18502,
	"./imgs/congresistas/ANTONIO CESAR RIVERA CALLEJAS.jpg": 29703,
	"./imgs/congresistas/ARIANA MELISSA BANEGAS CARCAMO.jpg": 11210,
	"./imgs/congresistas/ARMINDA URTECHO MIRALDA .jpg": 25249,
	"./imgs/congresistas/ARMINDA URTECHO MIRALDA.jpg": 32733,
	"./imgs/congresistas/BARTOLO ANTONIO FUENTES .jpg": 1542,
	"./imgs/congresistas/BARTOLO ANTONIO FUENTES.jpg": 6612,
	"./imgs/congresistas/BAYRON EDUARDO BANEGAS MEJIA.jpg": 97411,
	"./imgs/congresistas/BETTY ELIZABET RIVERA RAMIREZ.jpg": 47834,
	"./imgs/congresistas/BETTY RIVERBETTY ELIZABET RIVERA RAMIREZA.jpg": 57943,
	"./imgs/congresistas/BRAYAN ALONSO RUBI ACOSTA.jpg": 39681,
	"./imgs/congresistas/BRAYAN MIGUEL LAGOS ORDONEZ.jpg": 73208,
	"./imgs/congresistas/BRAYAN MIGUEL LAGOS ORDOÑEZ.jpg": 11667,
	"./imgs/congresistas/BRYAN MIGUEL LAGOS ORDOÑEZ.jpg": 17966,
	"./imgs/congresistas/CARLA BELINDA DIP ALVARADO.jpg": 61498,
	"./imgs/congresistas/CARLOS ALBERTO MEZA MEJIA.jpg": 96145,
	"./imgs/congresistas/CARLOS ALBERTO UMANA DAVID.jpg": 46946,
	"./imgs/congresistas/CARLOS ALBERTO UMAÑA DAVID.jpg": 77911,
	"./imgs/congresistas/CARLOS ALEXIS RAUDALES MARADIAGA.jpg": 34679,
	"./imgs/congresistas/CARLOS ARMANDO ZELAYA ROSALES.jpg": 45518,
	"./imgs/congresistas/CARLOS EDUARDO CANO MARTINEZ.jpg": 51416,
	"./imgs/congresistas/CARLOS ROBERTO LEDEZMA CASCO.jpg": 73687,
	"./imgs/congresistas/CESAR ALCIDES MADRID GAMEZ.jpg": 67591,
	"./imgs/congresistas/CESAR ANTONIO PINTO PACHECO.jpg": 92062,
	"./imgs/congresistas/CESAR HUMBERTO LOPEZ ALVARADO.jpg": 96865,
	"./imgs/congresistas/CINDY JULISSA SANTOS VILLAFRANCA.jpg": 44122,
	"./imgs/congresistas/CINTHYA CAROLINA AGURCIA CABRERA.jpg": 98494,
	"./imgs/congresistas/CLAUDIA ESTHER RAMIREZ CASTILLO.jpg": 70012,
	"./imgs/congresistas/CRISTHIAM JOSUE HERNANDEZ SAAVEDRA.jpg": 3067,
	"./imgs/congresistas/CRISTIAN DE JESUS HERNANDEZ DIAZ.jpg": 26064,
	"./imgs/congresistas/CRISTIAN JOSUE HERNANDEZ SAAVEDRA.jpg": 84096,
	"./imgs/congresistas/DAIRI JAVIER AVILA GABARRETE.jpg": 78277,
	"./imgs/congresistas/DANIEL HUMBERTO DISCUA GUIFARRO.jpg": 40894,
	"./imgs/congresistas/DANIEL ROBERTO REYNAUD CACERES.jpg": 43677,
	"./imgs/congresistas/DANY LEONEL MURILLO DIAZ.jpg": 53676,
	"./imgs/congresistas/DAVID SANIN MANAIZA RAMIREZ.jpg": 58285,
	"./imgs/congresistas/DELIA BEATRIZ VALLE MARICHAL.jpg": 23680,
	"./imgs/congresistas/DENIS ADALID OSEGUERA MARTINEZ.jpg": 18576,
	"./imgs/congresistas/DENNIS RIGOBERTO CHIRINOS SANTOS.jpg": 51250,
	"./imgs/congresistas/DORIS SANTOS MENDOZA .jpg": 25114,
	"./imgs/congresistas/DORIS SANTOS MENDOZA.jpg": 45296,
	"./imgs/congresistas/DUNIA YADIRA JIMENEZ AGUILAR.jpg": 68539,
	"./imgs/congresistas/EDER LEONEL MEJIA LAINEZ.jpg": 28315,
	"./imgs/congresistas/EDGARDO ANTONIO CASANA MEJIA.jpg": 61176,
	"./imgs/congresistas/EDGARDO HERNAN LOUCEL AGUILERA.jpg": 85505,
	"./imgs/congresistas/EDMAN CELIN MUNGUIA DUBON.jpg": 19197,
	"./imgs/congresistas/EDMAN CELIN MUNGUÍA DUBÓN.jpg": 67013,
	"./imgs/congresistas/EDUARDO DIAZ VELASQUEZ .jpg": 18949,
	"./imgs/congresistas/EDUARDO DIAZ VELASQUEZ.jpg": 93673,
	"./imgs/congresistas/EDUARDO HERBERT HALL LOPEZ.jpg": 30458,
	"./imgs/congresistas/EDWIN ALEXANDER PENA MATEO.jpg": 43790,
	"./imgs/congresistas/EDWIN ALEXANDER PEÑA MATEO.jpg": 90259,
	"./imgs/congresistas/ELBA MARIELA ESCOBAR ELVIR.jpg": 9989,
	"./imgs/congresistas/ELVIA LIZETTE URBINA SORTO.jpg": 18389,
	"./imgs/congresistas/ELVIN EMILIO HENRIQUEZ REYES.jpg": 62903,
	"./imgs/congresistas/ELVYN LENIN CABRERA HERNANDEZ.jpg": 35500,
	"./imgs/congresistas/ENRIQUE ALEJANDRO MATUTE DIAZ.jpg": 90882,
	"./imgs/congresistas/ENRIQUE BELPRAN MARTINEZ AVILA.jpg": 24871,
	"./imgs/congresistas/ERASMO JOSE PORTILLO PINTO.jpg": 4832,
	"./imgs/congresistas/ERIC ALEJANDRO FERNANDEZ ROSENTHAL.jpg": 62681,
	"./imgs/congresistas/ERIK JOSE ALVARADO ALVARADO.jpg": 2191,
	"./imgs/congresistas/ERIKA CORINA URTECHO ECHEVERRIA.jpg": 46489,
	"./imgs/congresistas/ERNESTO SALOMON LEZAMA DAVILA.jpg": 59835,
	"./imgs/congresistas/FANI NOEMI SANTOS PORTILLO.jpg": 24076,
	"./imgs/congresistas/FANNY MARIA GEVAWER MORENO.jpg": 18728,
	"./imgs/congresistas/FATIMA PATRICIA MENA BAIDE.jpg": 38966,
	"./imgs/congresistas/FAVIA ARACELY ORELLANA DISCUA.jpg": 76916,
	"./imgs/congresistas/FELIPE TOMAS PONCE ISAULA.jpg": 96898,
	"./imgs/congresistas/FRANCIS OMAR CABRERA MIRANDA.jpg": 39466,
	"./imgs/congresistas/FRANCIS YOLANDA ARGENAL ECHENIQUE.jpg": 68482,
	"./imgs/congresistas/FRANCIS YOLANDA ARGEÑAL ECHENIQUE.jpg": 52541,
	"./imgs/congresistas/FRANCISCO ANTONIO LOPEZ CRUZ.jpg": 40373,
	"./imgs/congresistas/GERMAN OSWALDO ALTAMIRANO DIAZ.jpg": 57548,
	"./imgs/congresistas/GLADIS AURORA LOPEZ CALDERON.jpg": 64170,
	"./imgs/congresistas/GLORIA ARGENTINA BONILLA BONILLA.jpg": 206,
	"./imgs/congresistas/GONZALO JOSE RIVERA MEDRANO.jpg": 55913,
	"./imgs/congresistas/GRIMALDI JOSUE PAZ SOSA.jpg": 96015,
	"./imgs/congresistas/GUSTAVO ADOLFO GONZALEZ AGUILAR.jpg": 43960,
	"./imgs/congresistas/GUSTAVO ALBERTO CACERES BANEGAS.jpg": 87142,
	"./imgs/congresistas/GUSTAVO ENRIQUE GONZALEZ MALDONADO.jpg": 12626,
	"./imgs/congresistas/HECTOR HERNAN AGUILAR RODRIGUEZ.jpg": 73970,
	"./imgs/congresistas/HECTOR SAMUEL MADRID SABILLON.jpg": 98160,
	"./imgs/congresistas/HECTOR VIDAL CERRATO ZELAYA.jpg": 95856,
	"./imgs/congresistas/HERMANN MIGUEL MEJIA AGUILAR.jpg": 37296,
	"./imgs/congresistas/HERNAN GUEVARA REYES .jpg": 27434,
	"./imgs/congresistas/HERNAN GUEVARA REYES.jpg": 26048,
	"./imgs/congresistas/HODALMA LISSETH BENITES ERAZO.jpg": 61266,
	"./imgs/congresistas/HODALMA LISSETH BENITEZ ERAZO.jpg": 26199,
	"./imgs/congresistas/HUGO ROLANDO NOE PINO.jpg": 67845,
	"./imgs/congresistas/IRIS YANETH PINEDA PAZ.jpg": 34013,
	"./imgs/congresistas/IROSKA LINDALY ELVIR FLORES.jpg": 88140,
	"./imgs/congresistas/ISIS CAROLINA CUELLAR ERAZO.jpg": 13065,
	"./imgs/congresistas/IVETH OBDULIA MATUTE BETANCOURTH.jpg": 19450,
	"./imgs/congresistas/IVIN JANETH FONSECA TREJO.jpg": 64834,
	"./imgs/congresistas/IVIN YANETH FONSECA TREJO.jpg": 67499,
	"./imgs/congresistas/JAK MELEM URIARTE VELASQUEZ.jpg": 46559,
	"./imgs/congresistas/JARI DIXON HERRERA HERNANDEZ.jpg": 33385,
	"./imgs/congresistas/JAVIER ADOLFO MIRALDA VILLALOBOS.jpg": 18238,
	"./imgs/congresistas/JAVIER ALEJANDRO MENDIETA SERVELLON.jpg": 63667,
	"./imgs/congresistas/JAVIER TRIGUEROS SAAVEDRA .jpg": 1803,
	"./imgs/congresistas/JERRY MEL DIAZ MURILLO.jpg": 49731,
	"./imgs/congresistas/JESSER JOEL CORRALES FLORES.jpg": 1625,
	"./imgs/congresistas/JHOSY SADDAM TOSCANO RAMIREZ.jpg": 30047,
	"./imgs/congresistas/JOHANA GUICEL BERMUDEZ LACAYO.jpg": 90252,
	"./imgs/congresistas/JOHANNA ELIZABETH  MARTINEZ CHAVEZ.jpg": 47531,
	"./imgs/congresistas/JOHANNA ELIZABETH MARTINEZ CHAVEZ.jpg": 29833,
	"./imgs/congresistas/JOHN MILTON GARCIA FLORES.jpg": 37025,
	"./imgs/congresistas/JORGE ALBERTO GAMEZ ROBLES.jpg": 8030,
	"./imgs/congresistas/JORGE ALBERTO ZELAYA MUNGUIA.jpg": 20103,
	"./imgs/congresistas/JORGE LUIS CALIX ESPINAL.jpg": 11486,
	"./imgs/congresistas/JORGE LUIS GAIDO CUELLAR.jpg": 92185,
	"./imgs/congresistas/JORGE VICTOR DIAZ ENAMORADO.jpg": 29821,
	"./imgs/congresistas/JOSE ALFREDO SAAVEDRA PAZ.jpg": 36855,
	"./imgs/congresistas/JOSE ANTONIO LAINEZ MEJIA.jpg": 45121,
	"./imgs/congresistas/JOSE ARMANDO AMAYA CASTILLO.jpg": 20300,
	"./imgs/congresistas/JOSE DAVID RODRIGUEZ REYES.jpg": 7955,
	"./imgs/congresistas/JOSE EDGARDO CASTRO RODRIGUEZ.jpg": 6195,
	"./imgs/congresistas/JOSE JAAR MUDENAT .jpg": 41486,
	"./imgs/congresistas/JOSE JAAR MUDENAT.jpg": 37260,
	"./imgs/congresistas/JOSE MANUEL MATHEU AMAYA.jpg": 84091,
	"./imgs/congresistas/JOSE MANUEL RODRIGUEZ ROSALES.jpg": 18858,
	"./imgs/congresistas/JOSE NECTALI JUAREZ .jpg": 61095,
	"./imgs/congresistas/JOSE NECTALI JUAREZ.jpg": 74871,
	"./imgs/congresistas/JOSE NECTALY JUAREZ.jpg": 4807,
	"./imgs/congresistas/JOSE OVED LOPEZ RODRIGUEZ.jpg": 62911,
	"./imgs/congresistas/JOSE ROSARIO TEJEDA TEJEDA.jpg": 39979,
	"./imgs/congresistas/JOSE TOMAS ZAMBRANO MOLINA.jpg": 84530,
	"./imgs/congresistas/JOSE VIRGILIO GARCIA ALDANA.jpg": 4439,
	"./imgs/congresistas/JOSUE DAVID COLINDRES CASTELLANOS.jpg": 18385,
	"./imgs/congresistas/JOSUE FABRICIO CARBAJAL SANDOVAL.jpg": 280,
	"./imgs/congresistas/JUAN ALBERTO BARAHONA MEJIA.jpg": 94182,
	"./imgs/congresistas/JUAN ANGEL LANZA SABILLON.jpg": 35712,
	"./imgs/congresistas/JUAN CARLOS OLIVA BRIZIO.jpg": 23741,
	"./imgs/congresistas/JUAN RAMON FLORES BUEZO.jpg": 9042,
	"./imgs/congresistas/KAREN VANESA ACOSTA BAQUEDANO.jpg": 19343,
	"./imgs/congresistas/KAREN VANESSA MARTINEZ BARAHONA.jpg": 2185,
	"./imgs/congresistas/KARLA MELISSA EUCEDA FUNEZ.jpg": 43695,
	"./imgs/congresistas/KARLA PATRICIA FIGUEROA CARDOZA.jpg": 43277,
	"./imgs/congresistas/KARLIN ISVELA ALVAREZ PAZ.jpg": 82024,
	"./imgs/congresistas/KATHIA MARCELA CRIVELLI RAMIREZ.jpg": 58580,
	"./imgs/congresistas/KATY MARISELA EUCEDA BARDALES.jpg": 73157,
	"./imgs/congresistas/KELY YAJAIRA AGUILAR ESCALANTE.jpg": 42318,
	"./imgs/congresistas/KENNIA YAMILETH MONTERO MARTINEZ.jpg": 93794,
	"./imgs/congresistas/KRITZA JERLIN PEREZ GALLEGOS.jpg": 28492,
	"./imgs/congresistas/LEDA LINETH AGURCIA ESPINOZA.jpg": 50498,
	"./imgs/congresistas/LEDA LIZETHE GARCIA PAGAN.jpg": 27494,
	"./imgs/congresistas/LEONEL LOPEZ ORELLANA .jpg": 74110,
	"./imgs/congresistas/LEONEL LOPEZ ORELLANA.jpg": 5308,
	"./imgs/congresistas/LEOVIGILDO REYES REYES .jpg": 21931,
	"./imgs/congresistas/LEOVIGILDO REYES REYES.jpg": 94563,
	"./imgs/congresistas/LESLY CAROLINA FLORES MENDEZ.jpg": 93227,
	"./imgs/congresistas/LESTER ANTONIO AGUILAR CASTRO.jpg": 66671,
	"./imgs/congresistas/LIGIA DEL CARMEN RAMOS ZUNIGA.jpg": 86964,
	"./imgs/congresistas/LINDA FRANCES DONAIRE PORTILLO.jpg": 53402,
	"./imgs/congresistas/LINDA KAREN ULLOA GUERRERO.jpg": 69320,
	"./imgs/congresistas/LISSI MARCELA MATUTE CANO.jpg": 16127,
	"./imgs/congresistas/LOURDES ERNESTINA FAJARDO RAMOS.jpg": 51391,
	"./imgs/congresistas/LOURDES MARIBEL MEJIA ESTAPE.jpg": 56755,
	"./imgs/congresistas/LUIS ANTONIO AMADOR MENDOZA.jpg": 1836,
	"./imgs/congresistas/LUIS ENRIQUE ORTEGA SANCHEZ.jpg": 2985,
	"./imgs/congresistas/LUIS GEOVANY MARTINEZ SANCHEZ.jpg": 3769,
	"./imgs/congresistas/LUIS ROLANDO REDONDO GUIFARRO.jpg": 92883,
	"./imgs/congresistas/LUZ ANGELICA SMITH MEJIA.jpg": 18121,
	"./imgs/congresistas/MARCO ANTONIO HANDAL CUBERO.jpg": 97577,
	"./imgs/congresistas/MARCO ANTONIO MIDENCE MILLA.jpg": 12031,
	"./imgs/congresistas/MARCO AURELIO TINOCO URBINA.jpg": 50583,
	"./imgs/congresistas/MARCO ELIUD GIRON PORTILLO.jpg": 50332,
	"./imgs/congresistas/MARCO TULIO RODRIGUEZ GAVARRETE.jpg": 2068,
	"./imgs/congresistas/MARCOS ANTONIO VELASQUEZ .jpg": 15896,
	"./imgs/congresistas/MARCOS ANTONIO VELASQUEZ.jpg": 22954,
	"./imgs/congresistas/MARCOS BERTILIO PAZ SABILLON.jpg": 79005,
	"./imgs/congresistas/MARDEL WOOD MADSIN .jpg": 87231,
	"./imgs/congresistas/MARDEL WOOD MADSIN.jpg": 3103,
	"./imgs/congresistas/MARGARITA DABDOUB SIKAFFI .jpg": 36461,
	"./imgs/congresistas/MARIA ANTONIETA MEJIA SANCHEZ.jpg": 44344,
	"./imgs/congresistas/MARIA DEL SOCORRO JACOME.jpg": 27520,
	"./imgs/congresistas/MARIA ISABEL VALDEZ BRIONES.jpg": 65277,
	"./imgs/congresistas/MARIA MAGDALENA MORALES ANDINO.jpg": 60783,
	"./imgs/congresistas/MARIBEL ESPINOZA TURCIOS .jpg": 44319,
	"./imgs/congresistas/MARIBEL ESPINOZA TURCIOS.jpg": 91999,
	"./imgs/congresistas/MARIO ALBERTO GONZALES MARTINEZ.jpg": 33943,
	"./imgs/congresistas/MARIO ALONSO PEREZ LOPEZ.jpg": 65303,
	"./imgs/congresistas/MARIO AMILCAR PORTILLO CONTRERAS.jpg": 41476,
	"./imgs/congresistas/MARIO EDGARDO SEGURA  AROCA.jpg": 12740,
	"./imgs/congresistas/MARIO EDGARDO SEGURA AROCA.jpg": 34882,
	"./imgs/congresistas/MARIO ENRIQUE CALIX LARA.jpg": 91513,
	"./imgs/congresistas/MARIO ORLANDO REYES MEJIA.jpg": 69796,
	"./imgs/congresistas/MARIO ORLANDO REYEZ MEJIA.jpg": 2849,
	"./imgs/congresistas/MARIO RAFAEL ARGENAL MEDINA.jpg": 18666,
	"./imgs/congresistas/MARIO RAFAEL ARGEÑAL MEDINA.jpg": 67691,
	"./imgs/congresistas/MARIO RAFAEL ARGUEÑAL MEDINA.jpg": 73842,
	"./imgs/congresistas/MARIO RENE HENRIQUEZ PINEDA.jpg": 21137,
	"./imgs/congresistas/MARLIN JOEL PERAZA SARMIENTO.jpg": 56929,
	"./imgs/congresistas/MARLON GUILLERMO LARA ORELLANA.jpg": 30094,
	"./imgs/congresistas/MARLON HENRY RODRIGUEZ RODRIGUEZ.jpg": 8756,
	"./imgs/congresistas/MARTHA CONCEPCION FIGUEROA TORRES.jpg": 15468,
	"./imgs/congresistas/MAURICIO ANTONIO CASTELLANOS QUIROZ.jpg": 75767,
	"./imgs/congresistas/MAURICIO ORLANDO RIVERA LOPEZ.jpg": 17338,
	"./imgs/congresistas/MAURICIO VILLEDA BERMUDEZ .jpg": 99069,
	"./imgs/congresistas/MAYRA ROSIBEL PAVON UMANZOR.jpg": 8945,
	"./imgs/congresistas/MELBI CONCEPCION ORTIZ MURILLO.jpg": 49313,
	"./imgs/congresistas/MELVIN ROBERTO PAREDES MILLA.jpg": 54898,
	"./imgs/congresistas/MERARY ELENA DIAZ MOLINA.jpg": 24766,
	"./imgs/congresistas/MERLIN ORBELIANY ANDRADE ESPINAL.jpg": 52758,
	"./imgs/congresistas/MILTON JESUS PUERTO OSEGUERA.jpg": 38292,
	"./imgs/congresistas/MIREYA EDITH GUILLEN ARGUETA.jpg": 61245,
	"./imgs/congresistas/NASSER GABRIEL RODRIGUEZ URQUIA.jpg": 88833,
	"./imgs/congresistas/NELSON GEOVANY LEIVA RODRIGUEZ.jpg": 28933,
	"./imgs/congresistas/NELSON JAVIER MARQUEZ EUCEDA.jpg": 18743,
	"./imgs/congresistas/NESTOR JOSUE YANES ORELLANA.jpg": 58834,
	"./imgs/congresistas/NETZER EDU MEJIA HERNANDEZ.jpg": 20302,
	"./imgs/congresistas/NORA DEL CARMEN SUAREZ BUSTAMANTE.jpg": 15848,
	"./imgs/congresistas/NORMA ARACELY AGUILAR CHACON.jpg": 9070,
	"./imgs/congresistas/OSCAR ARIEL MONTOYA RODEZNO.jpg": 17296,
	"./imgs/congresistas/OSCAR ARMANDO FLORES FUENTES.jpg": 66210,
	"./imgs/congresistas/OSCAR NOEL MARQUEZ GONZALES.jpg": 86823,
	"./imgs/congresistas/OSMAN DANILO CHAVEZ GUITY.jpg": 54913,
	"./imgs/congresistas/PABLO HUMBERTO CARRASCO ASCENCIO.jpg": 8006,
	"./imgs/congresistas/PABLO RAMON SOTO BONILLA.jpg": 87068,
	"./imgs/congresistas/PABLO ROBERTO MUNGUIA LOZANO.jpg": 47917,
	"./imgs/congresistas/PEDRO ANTONIO CHAVEZ MADISON.jpg": 50963,
	"./imgs/congresistas/RAFAEL ALBERTO LOPEZ MENJIVAR.jpg": 25357,
	"./imgs/congresistas/RAFAEL LEONARDO SARMIENTO AGUIRIANO.jpg": 4781,
	"./imgs/congresistas/RAFAEL LEONARDO SARMIENTOS AGUIRIANO.jpg": 6804,
	"./imgs/congresistas/RAMON ENRIQUE BARRIOS MALDONADO.jpg": 3272,
	"./imgs/congresistas/RAMON ERNESTO BENITEZ CRUZ.jpg": 9487,
	"./imgs/congresistas/RAMON FERNANDO CARRANZA DISCUA.jpg": 23798,
	"./imgs/congresistas/RASEL ANTONIO TOME FLORES.jpg": 12710,
	"./imgs/congresistas/RAYMOND SAMUEL CHERINGTON JOHNSON.jpg": 54034,
	"./imgs/congresistas/REBECA ANGELINA AVILA BACA.jpg": 79258,
	"./imgs/congresistas/REINALDO ANTONIO SANCHEZ RIVERA.jpg": 53998,
	"./imgs/congresistas/RIGOBERTO MIRANDA TOLEDO .jpg": 6345,
	"./imgs/congresistas/RIGOBERTO MIRANDA TOLEDO.jpg": 93557,
	"./imgs/congresistas/ROGELIO DE LA CRUZ SANCHEZ AGUILAR.jpg": 55641,
	"./imgs/congresistas/ROGNER ARMANDO AGUILERA CABRERA.jpg": 59090,
	"./imgs/congresistas/ROLANDO ENRIQUE BARAHONA PUERTO.jpg": 37682,
	"./imgs/congresistas/ROLANDO MARCIA EUCEDA .jpg": 10246,
	"./imgs/congresistas/ROLANDO MARCIA EUCEDA.jpg": 88404,
	"./imgs/congresistas/ROMAN MORAN CABRERA .jpg": 30423,
	"./imgs/congresistas/ROMAN MORAN CABRERA.jpg": 71111,
	"./imgs/congresistas/ROMMEL DARIO MORAN ESPINAL.jpg": 60593,
	"./imgs/congresistas/RONAL EMERITO PINEDA LEIVA.jpg": 8628,
	"./imgs/congresistas/RONALD EDGARDO PANCHAME URQUIA.jpg": 26819,
	"./imgs/congresistas/ROSA ADELINDA PAVON .jpg": 65990,
	"./imgs/congresistas/ROY DAGOBERTO CRUZ PEREZ.jpg": 94134,
	"./imgs/congresistas/RUMY NAHYP BUESO MEZA.jpg": 49131,
	"./imgs/congresistas/SALVADOR MELGHEM BENITEZ .jpg": 77591,
	"./imgs/congresistas/SALVADOR MELGHEM BENITEZ.jpg": 34343,
	"./imgs/congresistas/SAMUEL ARMANDO DE JESUS GARCIA SALGADO.jpg": 56921,
	"./imgs/congresistas/SAMUEL DUARTE ALVARADO .jpg": 85723,
	"./imgs/congresistas/SAMUEL DUARTE ALVARADO.jpg": 70803,
	"./imgs/congresistas/SAQUIRY REYNALDO GUARDADO VASQUEZ.jpg": 58433,
	"./imgs/congresistas/SCHERLY MELISSA ARRIAGA GOMEZ.jpg": 14224,
	"./imgs/congresistas/SELVIN OCTAVIO MORALES BONILLA.jpg": 11331,
	"./imgs/congresistas/SERGIO ARTURO CASTELLANOS PERDOMO.jpg": 59220,
	"./imgs/congresistas/SERGIO FIGUEROA VELASQUEZ .jpg": 4148,
	"./imgs/congresistas/SERGIO FIGUEROA VELASQUEZ.jpg": 78718,
	"./imgs/congresistas/SILVIA BESSY AYALA FIGUEROA.jpg": 82287,
	"./imgs/congresistas/SONIA YASMARA BARAHONA SANCHEZ.jpg": 33889,
	"./imgs/congresistas/SUYAPA MARIA FIGUEROA EGUIGUREMS.jpg": 69755,
	"./imgs/congresistas/TANIA GABRIELA PINTO PACHECO.jpg": 20430,
	"./imgs/congresistas/TERESA CONCEPCION CALIX RAUDALES.jpg": 78044,
	"./imgs/congresistas/TIBDEO RICARDO ELENCOFF MARTINEZ.jpg": 8994,
	"./imgs/congresistas/TOMAS ANTONIO RAMIREZ HERNANDEZ.jpg": 3276,
	"./imgs/congresistas/VALESKA YAMILETH VALENZUELA CHAVEZ.jpg": 11197,
	"./imgs/congresistas/VICTOR HUGO ROMERO CHINCHILLA.jpg": 22992,
	"./imgs/congresistas/VICTOR MANUEL GRAJEDA RODRIGUEZ.jpg": 28415,
	"./imgs/congresistas/VICTOR ROLANDO SABILLON SABILLON.jpg": 90257,
	"./imgs/congresistas/VICTOR SEBASTIAN MUNGUIA RIVERA.jpg": 6977,
	"./imgs/congresistas/WALTER ANTONIO CHAVEZ HERNANDEZ.jpg": 58254,
	"./imgs/congresistas/WILFREDO SANTIAGO SABIO CACHO.jpg": 37363,
	"./imgs/congresistas/WILMER ENRIQUE CRUZ PAREDES.jpg": 60254,
	"./imgs/congresistas/WILSON ROLANDO PINEDA DIAZ.jpg": 7809,
	"./imgs/congresistas/XIOMARA HORTENCIA ZELAYA CASTRO.jpg": 47373,
	"./imgs/congresistas/YAHVE SALVADOR SABILLON CRUZ.jpg": 49230,
	"./imgs/congresistas/YARI VIANEY SEQUEIRA AVILA.jpg": 42180,
	"./imgs/congresistas/YAUDET BURBARA CANAHUATI .jpg": 41388,
	"./imgs/congresistas/YAUDET BURBARA CANAHUATI.jpg": 75142,
	"./imgs/congresistas/YAVHE SALVADOR SABILLON CRUZ.jpg": 33290,
	"./imgs/congresistas/YURY CRISTHIAN SABAS GUTIERREZ.jpg": 81540,
	"./imgs/diagrama-completo-4.jpg": 48380,
	"./imgs/diagrama-completo-transparente.png": 27741,
	"./imgs/logo.png": 21212,
	"./imgs/mapa-votacion.jpg": 61758,
	"./imgs/notfound.png": 35128,
	"./imgs/notfound_600x600.png": 25713,
	"./imgs/papeletas/papeleta_individual.png": 52613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82698;